import React, { useEffect } from 'react';
import { Button, Typography, Tag, Badge } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './styles/SmsConversationProfile.less';
import UserAvatar from '../../../elements/containers/UserAvatarContainer';
import { Translation } from 'react-i18next';
import Format from '../../../../../lib/Format';

const { Title } = Typography;

const SmsConversationProfile = ({
  load,
  careGuideId,
  partnershipId,
  smsConversation,
  onClose,
  data,
  loadTags,
  adminPartnerClassesAdmin,
}) => {
  useEffect(() => {
    if (partnershipId && careGuideId) {
      load(partnershipId, careGuideId);
    }
  }, [careGuideId, partnershipId, load]);

  useEffect(() => {
    if (partnershipId) {
      loadTags(partnershipId);
    }
  }, [partnershipId, loadTags]);

  if (!smsConversation) {
    return null;
  }
  return (
    <Translation>
      {(t) => (
        <div className='sms-conversation-profile'>
          <div className='profile-header'>
            <Title level={4} className='profile-title'>
              {t('sms_conversations_profile')}
            </Title>
            <Button
              type='text'
              icon={<CloseOutlined />}
              onClick={onClose}
              className='close-button'
            />
          </div>

          <div className='profile-content'>
            <div className='profile-user'>
              <UserAvatar user={data} size={40} />
              <Title level={4} className='profile-title'>
                {data?.first_name} {data?.last_name}
              </Title>

              {data?.status === 1 ? (
                <span className='profile-status-active'>
                  <Badge color='#22C55E' />
                  {t('member_profile_state_active')}
                </span>
              ) : (
                <span className='profile-status-inactive'>
                  <Badge color={'#A5A5A5'} className='status-badge' />
                  {t('member_profile_state_pending')}
                </span>
              )}

              <Tag color='#5399DD' style={{ borderRadius: '50px' }}>
                {t('member_profile_role_caregiver')}
              </Tag>
            </div>

            <div className='profile-section'>
              
            <div className='section-item'>
              <div className='item-label'>
                {t(
                  'sms_conversations_member_profile_care_recipient'
                )}
              </div>
              <div className='item-value'>
                {smsConversation?.care_guide_name}
              </div>
            </div>

              <Title level={5} className='section-title'>
                {t('sms_conversations_member_profile_tags')}
              </Title>

              {adminPartnerClassesAdmin &&
                Array.isArray(adminPartnerClassesAdmin) &&
                adminPartnerClassesAdmin.map((partnerClass) => {
                  const matchingTag = data?.care_partner_tags?.find(
                    (tag) => tag?.admin_partner_class?.id === partnerClass.id
                  );
                  return (
                    <div className='section-item' key={partnerClass.id}>
                      <div className='item-label'>{partnerClass?.name}:</div>
                      <div className='item-value'>
                        {matchingTag?.label || 'Unassigned'}
                      </div>
                    </div>
                  );
                })}
            </div>
            {(data?.telephone || data?.email) && (
              <div className='profile-section'>
                <Title level={5} className='section-title'>
                  {t('sms_conversations_member_personal_information')}
                </Title>
                {data?.telephone && (
                  <div className='section-item'>
                    <div className='item-label'>
                      {t(
                        'sms_conversations_member_personal_information_phone_number'
                      )}
                    </div>
                    <div className='item-value'>
                      {Format.telephone(data?.telephone)}
                    </div>
                  </div>
                )}
                {data?.email && (
                  <div className='section-item'>
                    <div className='item-label'>
                      {t('sms_conversations_member_personal_information_email')}
                    </div>
                    <div className='item-value'>{data?.email}</div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </Translation>
  );
};

export default SmsConversationProfile;
